<div class="body">
    <app-navbar></app-navbar>
<div>
    
    <div class="heading-rounds-white">
        <h1><span class="headi">PAST WINNERS</span> </h1>
    </div>
    <div class="criteria">
            <div class="new">
                <div class="new2">
                    <div class="header">
                        <h4>Dehaat</h4>
                    </div>
                    <div class="imx">
                        <img src="assets/images/dehaat.webp" alt="">
                    </div>
                    <div class="header">
                    </div>
                    <div  class="new3">
                        <p>DeHaat is one of the fastest-growing start-ups in the Agri Tech sector and one of the very few companies providing end-to-end solutions and services to the farming community in India.
                            Series E funded and raised a total of $224.3M in all rounds.
                            Recognized and felicitated by NASSCOM, Forbes, ET, Niti Aayog, Bill Gates Foundation, and many more.
                            Connected with 650,000 farmers
                            </p>
                </div>
                <!-- <div class="knowmore">
                    <div class="butbut" >
                        <p class="know-more" > &nbsp; BUSINESS TRACK &nbsp;</p>
                        <p class="know-more" > &nbsp; SOCIAL TRACK &nbsp;</p>

                    </div>
                </div> -->
                </div>
            </div>
            <div class="new">
                <div class="new2">
                    <div class="header">
                        <h4>Socialcops</h4>
                    </div>
                    <div class="imx">
                        <img src="assets/images/socialcops.jpeg" alt="">
                    </div>
                    <div class="header">
                    </div>
                    <div  class="new3">
                        <p>Socialcops is confronting the world’s critical problems through data intelligence. 
                            Series C funded and raised total of $201.5M in lifetime by Salesforce Ventures. Insight Partners, Sequoia Capital etc. Technology Pioneer Award, World Economic Forum(2018) Global VIsionary Award, NYT(2018)
                            
                            </p>
                </div>
                <!-- <div class="knowmore">
                    <div class="butbut" >
                        <p class="know-more" > &nbsp; BUSINESS TRACK &nbsp;</p>
                        <p class="know-more" > &nbsp; SOCIAL TRACK &nbsp;</p>

                    </div>
                </div> -->
                </div>
            </div>
            <div class="new">
                <div class="new2">
                    <div class="header">
                        <h4>Pratilipi</h4>
                    </div>
                    <div class="imx">
                        <img src="assets/images/pratilipi.png" alt="">
                    </div>
                    <div class="header">
                    </div>
                    <div  class="new3">
                        <p>Pratilipi is a platform which brings 2.5 Cr+ readers, 2.7L+ writers and 27L+ stories together in 12 languages
                            Series D funded and raised total of $81.1M in lifetime from Tencent, Krafton, etc.
                            </p>
                </div>
                <!-- <div class="knowmore">
                    <div class="butbut" >
                        <p class="know-more" > &nbsp; BUSINESS TRACK &nbsp;</p>
                        <p class="know-more" > &nbsp; SOCIAL TRACK &nbsp;</p>

                    </div>
                </div> -->
                </div>
            </div>
            <div class="new">
                <div class="new2">
                    <div class="header">
                        <h4>Zostel</h4>
                    </div>
                    <div class="imx">
                        <img src="assets/images/zostel.png" alt="">
                    </div>
                    <div class="header">
                    </div>
                    <div  class="new3">
                        <p>Zostel is like a hostel that provides a home environment with all of the necessary conveniences at an affordable price.
                            Connected with 500+ hostels across India, total funding received of $13.8M from Tiger Global Management, Orios Venture Partners, etc.                             </p>
                </div>
                <!-- <div class="knowmore">
                    <div class="butbut" >
                        <p class="know-more" > &nbsp; BUSINESS TRACK &nbsp;</p>
                        <p class="know-more" > &nbsp; SOCIAL TRACK &nbsp;</p>

                    </div>
                </div> -->
                </div>
            </div>
            <div class="new">
                <div class="new2">
                    <div class="header">
                        <h4> P-TAL</h4>
                    </div>
                    <div class="imx">
                        <img src="assets/images/ptal.jpeg" alt="">
                    </div>
                    <div class="header">
                    </div>
                    <div  class="new3">
                        <p>P-TAL’s mission is to revive the age old traditions in a contemporary manner and sells handcrafted copper and brass home decor & kitchenware
                            Closed an all Shark Deal at Shark Tank India and total total funding received of $500k+ in lifetime. </p>
                </div>
                <!-- <div class="knowmore">
                    <div class="butbut" >
                        <p class="know-more" > &nbsp; BUSINESS TRACK &nbsp;</p>
                        <p class="know-more" > &nbsp; SOCIAL TRACK &nbsp;</p>

                    </div>
                </div> -->
                </div>
            </div>
            <div class="new">
                <div class="new2">
                    <div class="header">
                        <h4>Aviotron Aerospace</h4>
                    </div>
                    <div class="imx">
                        <img src="assets/images/aviotron.jpeg" alt="">
                    </div>
                    <div class="header">
                    </div>
                    <div  class="new3">
                        <p>Aviotron Aerospace is an Ed-Tech startup founded by 4 passionate and young entrepreneurs with a core vision of empowering our youth with much needed 21st-century skills such as creativity, innovation, problem-solving, and focus. 
                            Received a total funding received of $800k+ from Enrission India in E-Summit'24.</p>
                </div>
                <!-- <div class="knowmore">
                    <div class="butbut" >
                        <p class="know-more" > &nbsp; BUSINESS TRACK &nbsp;</p>
                        <p class="know-more" > &nbsp; SOCIAL TRACK &nbsp;</p>

                    </div>
                </div> -->
                </div>
            </div>
            <div class="new">
                <div class="new2">
                    <div class="header">
                        <h4> Golden Feathers (Mudita and Radhesh Pvt. Ltd.)</h4>
                    </div>
                    <div class="imx">
                        <img src="assets/images/golden.png" alt="">
                    </div>
                    <div class="header">
                    </div>
                    <div  class="new3">
                        <p>Golden Feathers transforms chicken waste into a superior, sustainable woolen fiber, revolutionizing textiles and paper while empowering tribal women through handloom craftsmanship.</p>
                </div>
                <div class="knowmore">
                    <div class="butbut" >
                        <p class="know-more" > &nbsp; WINNER &nbsp;</p>
                        <p class="know-more" > &nbsp; BUSINESS TRACK &nbsp;</p>

                    </div>
                </div>
                </div>
            </div>
            <div class="new">
                <div class="new2">
                    <div class="header">
                        <h4>Cattleguru Pvt. Ltd.</h4>
                    </div>
                    <div class="imx">
                        <img src="assets/images/cattle.png" alt="">
                    </div>
                    <div class="header">
                    </div>
                    <div  class="new3">
                        <p>Direct to Farmer brand of cattle feed for dairy farmers.
                        </p>
                </div>
                <div class="knowmore">
                    <div class="butbut" >
                        <p class="know-more" > &nbsp; FIRST RUNNER UP &nbsp;</p>

                        <p class="know-more" > &nbsp; BUSINESS TRACK &nbsp;</p>

                    </div>
                </div>
                </div>
            </div>
        </div>
       
    
</div>
    <app-footer></app-footer>
    
</div>


